module.exports = __webpack_public_path__ + "img/gongye.2fb2230f.jpg";